export const slugGenerator = (text) => text.normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[\W]/g, '')
  .toLowerCase()

export const encodeEmbedData = (string) => {
  let charCode = ''
  for (let letra of string) {
    charCode += (letra.charCodeAt(0) + 2).toString() + '.'
  }
  return btoa(charCode)
}

export const decodeEmbedData = (encodedString) => {
  try {
    // Convert Base64 to String and get charcode of chars
    const charCodeArr = atob(encodedString).split('.')
    let decodedData = ''
    charCodeArr.map((char) => {
      if (char !== '') {
        // convert charcode to String
        const character = String.fromCharCode((char - 2))
        decodedData += character
      }
    })
    return decodedData
  } catch (ignored) {
    return false
  }
}

export const formatFileForSendWidget = (base64) => {
  let file = base64
  const getMimeType = file.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)
  let mimeType = getMimeType[1]

  return { file, mimeType }
}

export const findValueIntoObject = (objectRaw, searchValue, defaultValue = 'N/A') => {
  try {
    let value = objectRaw
    if (searchValue.includes('.')) {
      let breakPositionInArray = searchValue.split('.')
      for (let position of breakPositionInArray) {
        value = value[`${position}`]
      }
    } else {
      value = objectRaw[`${searchValue}`]
    }
    return value
  } catch (e) {
    return defaultValue
  }
}

export const formatAddress = ({
  street,
  number,
  city,
  district,
  complement,
  state
}) => {
  let fullAddress = ''
  if (street) {
    fullAddress += street
    if (number) {
      fullAddress += ', ' + number
    }
  }

  if (complement) {
    fullAddress += ' - ' + complement
  }

  if (district) {
    fullAddress += ', ' + district
  }

  if (city) {
    fullAddress += ', ' + city
  }

  if (state) {
    fullAddress += ' - ' + state
  }

  return fullAddress
}
